module.exports = __webpack_public_path__ + "img/arrow-go-forward-line-active.01e42522.svg";